const laboratoriesStrings = {
  vendorsHeader: {
    allVendorsFilterItem: 'All Labs',
    createVendorButton: 'Add Lab',
    vendorsFilterSearchBarPlaceholder: 'Lab Name',
  },

  vendorsList: {
    vendorGridNoResultsFound: 'No results matching your search criteria',
    vendorGridHeader: {
      vendorNameGridHeader: 'Lab Name',
      vendorStatusGridHeader: 'Status',
      vendorContactPersonGridHeader: 'Contact Person',
      vendorContactsGridHeader: 'Contacts',
      vendorDeliveryRadiusGridHeader: 'Delivery Radius',
      vendorDeliveryChargeGridHeader: 'Delivery Charge',
    },
    vendorDistanceUnit(distance) {
      return `${distance} km`;
    },
    vendorPartnershipDistanceUnit(distance) {
      return `Partnership ${distance} km`;
    },
    vendorGridItemCount: 'Items',
  },

  vendorDetailsHeader: {},

  vendorDetailsContent: {
    vendorDetailsContentConfirmButtonLabel: 'Add Lab',
    vendorDetailsContentEditButtonLabel: 'Edit Lab',
    vendorDetailsContentCancelButtonLabel: 'Cancel',
    vendorDetailsFormFieldKeys: {
      englishName: 'englishName',
      englishDisplayName: 'englishDisplayName',
      englishAddress: 'englishAddress',
      arabicName: 'arabicName',
      arabicDisplayName: 'arabicDisplayName',
      arabicAddress: 'arabicAddress',
      location: 'location',
      lat: 'lat',
      long: 'long',
      contactPerson: 'contactPerson',
      email: 'email',
      phone: 'phone',
      deliveryRadius: 'deliveryRadius',
      partnershipDeliveryRadius: 'partnershipDeliveryRadius',
      deliveryCharge: 'deliveryCharge',
      adminNote: 'adminNote',
      isActive: 'isActive',
    },
    vendorDetailsFormFields: {
      englishName: 'English Legal Name',
      englishDisplayName: 'English Display Name',
      englishAddress: 'English Address',
      arabicName: 'Arabic Legal Name',
      arabicDisplayName: 'Arabic Display Name',
      arabicAddress: 'Arabic Address',
      location: 'Location',
      lat: 'Lat',
      long: 'Long',
      contactPerson: 'Contact Person',
      email: 'Email',
      phone: 'Phone',
      deliveryRadius: 'Delivery Radius',
      partnershipDeliveryRadius: 'Partnership Delivery Radius',
      deliveryCharge: 'Delivery Charge',
      adminNote: 'Admin Note',
      isActive: 'Is Active',
      // to avoid writing proptypes for each form field
      getFormFieldLabel(key) {
        return this[key];
      },
      formEmptyFieldError(key) {
        return `${this[key]} is required`;
      },
      formWrongFieldErrorText(key) {
        return `${this[key]} is incorrect`;
      },
    },
    vendorDetailsFormFieldsUnits: {
      lat: 'lat',
      long: 'long',
      deliveryRadius: 'km',
      partnershipDeliveryRadius: 'km',
      deliveryCharge: 'EGP',
      getFormFieldUnit(key) {
        return this[key];
      },
    },
  },
};

export default laboratoriesStrings;
